import React from "react";

import styles from "./rouletteCatItem.module.css";

export default function SexRouletteCategoryItem({ item, onClick, active }) {
  const handleClick = () => {
    onClick(item);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`${styles.card} ${active ? styles.active : ""}`}
    >
      <img src={item.imagem} alt={item.titulo} className="w-full" />
      <span>{item.titulo}</span>
    </button>
  );
}
